import { render, staticRenderFns } from "./ComponentFastTrade.vue?vue&type=template&id=2c0457ac"
import script from "./ComponentFastTrade.vue?vue&type=script&lang=js"
export * from "./ComponentFastTrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports